export const HoldbackPeriod = {
  NoHoldback: 0,
  OneMonth: 1,
  ThreeMonths: 3,
  SixMonths: 6,
  NineMonths: 9,
};
